module.exports = __webpack_public_path__ + "img/ceoMessage-1.1a7afcb2.jpg";